import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppState, AuthActionTypes } from '@app/core/ngrx';
import { Store } from '@ngrx/store';

@Component({
    selector: 'ecp-auth-logout',
    template: '',
    standalone: false
})
export class LogoutComponent implements OnInit {
  constructor(private store: Store<AppState>, private router: Router) {}

  ngOnInit(): void {
    this.store.dispatch({ type: AuthActionTypes.LOGOUT });
  }
}
